import { cn } from "@/lib/utils";
import useStore from "@/store/useStore";
import { Check } from "lucide-react";
import { useTranslations } from "next-intl";
import { PieceIcon } from "./pieces/piece-icon";
import { Badge } from "./shadcn/badge";
import { Card, CardContent } from "./shadcn/card";

const formatNumber = (price: number) =>
    new Intl.NumberFormat("tr-TR", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(price);

export default function PlanCard({ selectedPlan, item, onClick, type }: any) {
    const t = useTranslations("checkout");
    const { plan } = useStore((state) => state);
    const isSelected =
        selectedPlan?.Id === item?.Id || (!!plan && plan?.Id === item?.Id);

    const durationLabel =
        item?.Duration && (item?.Duration == 6 || item?.Duration == 1)
            ? item?.Duration + " " + t("monthly")
            : item?.Duration / 12 + " " + t("yearly");

    return (
        <Card
            className={cn(
                "hover:border-primary/60 h-full w-full cursor-pointer gap-2 py-4 transition-colors",
                { "border-primary ring-primary/40 ring-1": isSelected },
            )}
            onClick={onClick}
        >
            <CardContent className="flex h-full w-full flex-col justify-center px-4">
                {type && type == "giftOrder" && (
                    <div className="flex items-start justify-between gap-3">
                        <div className="flex min-w-0 flex-col items-start">
                            <span className="text-primary text-base font-bold break-words">
                                {'"' + item?.gifted_username + '"'}{" "}
                                {t("giftMembershipFor")}
                            </span>
                            <span className="text-muted-foreground text-xs italic">
                                {t("forOnePerson")} {durationLabel}{" "}
                                {t("membership")}
                            </span>
                        </div>
                        <div className="flex shrink-0 flex-col items-end">
                            <div className="whitespace-nowrap">
                                <span
                                    className="text-lg font-bold"
                                    id={`checkout-plan-price-amount-${item.Id}`}
                                >
                                    {`${item.Price}`} TL
                                </span>
                                <span className="text-muted-foreground text-sm">
                                    /{durationLabel}
                                </span>
                            </div>
                            <span className="text-muted-foreground text-xs italic">
                                1 adet
                            </span>
                        </div>
                    </div>
                )}
                {type && type == "donationOrder" && (
                    <div className="flex items-start justify-between gap-3">
                        <div className="flex min-w-0 flex-col items-start">
                            <span className="text-primary text-base font-bold break-words">
                                {t("suspendedMembership")}
                            </span>
                            <span className="text-muted-foreground text-xs italic">
                                {t("forNPeople", { count: item?.Amount })}{" "}
                                {durationLabel} {t("membership")}
                            </span>
                        </div>
                        <div className="flex shrink-0 flex-col items-end">
                            <div className="whitespace-nowrap">
                                <span
                                    className="text-lg font-bold"
                                    id={`checkout-plan-price-amount-${item.Id}`}
                                >
                                    {item.Price * item.Amount} TL
                                </span>
                                <span className="text-muted-foreground text-sm">
                                    /{durationLabel}
                                </span>
                            </div>
                            <span className="text-muted-foreground text-xs italic">
                                {item?.Amount} adet
                            </span>
                        </div>
                    </div>
                )}
                {(!type ||
                    type == "basketOrder" ||
                    type == "subscriptionOrder") && (
                    <div className="flex h-full flex-col gap-2">
                        {/* Header */}
                        <div className="flex items-center gap-1">
                            <PieceIcon
                                piece={item?.Piece}
                                className="text-primary h-5 w-5 sm:h-6 sm:w-6"
                            />
                            <h3 className="text-sm font-medium sm:text-base">
                                {item?.Title}
                            </h3>
                        </div>

                        {/* Badge */}
                        {item?.MarketingText1 && (
                            <Badge className="bg-success-foreground text-success gap-2 self-start rounded-lg px-3 py-1.5 text-xs font-semibold whitespace-normal">
                                <Check
                                    className="bg-success text-success-foreground h-3 w-3 shrink-0 rounded-full p-0.5"
                                    strokeWidth={4}
                                />
                                <span>{item?.MarketingText1}</span>
                            </Badge>
                        )}

                        {/* Description */}
                        {item?.Description && (
                            <p className="text-muted-foreground flex-1 text-xs">
                                {item?.Description}
                            </p>
                        )}

                        {/* Price */}
                        <div className="flex items-baseline">
                            <span
                                className="text-foreground text-xl font-bold sm:text-2xl"
                                id={`checkout-plan-price-amount-${item.Id}`}
                            >
                                ₺{formatNumber(item.Price)}
                            </span>
                            {item?.OriginalPrice && (
                                <span className="text-muted-foreground ml-1.5 self-start text-xs sm:text-sm">
                                    <s>₺{formatNumber(item.OriginalPrice)}</s>
                                </span>
                            )}
                        </div>
                    </div>
                )}
            </CardContent>
        </Card>
    );
}
